import React from "react";
import { CURRENT_DDA_FLOOR } from "../../../constants";

const LinkBankHeader = ({ stepIncomplete, accountsByLogin }) => {
  const existingAccounts = accountsByLogin?.length > 0;

  return (stepIncomplete ?
    <StepIncompleteHeader existingAccounts={existingAccounts} /> :
    <StepCompleteHeader existingAccounts={existingAccounts} />
  );
};

const StepCompleteHeader = ({ existingAccounts }) => {
  const stepDescriptionTextValue = existingAccounts ?
    "Connect additional accounts to increase chances of approval" :
    "Link your primary checking and savings account";

  const additionalPrompts = existingAccounts ? (
    <>
      <p>
        A minimum of {CURRENT_DDA_FLOOR} in total bank account balances is
        recommended for approval.
      </p>
      <br />
      <p>
      Higher total balances have greater chance of higher spending power.
      </p>
    </>
  ) : (
    <>
      <p>
        Bank linking is required for application submission. A
        minimum of {CURRENT_DDA_FLOOR} in total bank account balances is
        recommended for approval.
      </p>
      <br />
      Connect multiple bank accounts to increase your total
      balance and chance of approval.
    </>
  );

  return (
    <>
      <div className="stepDescriptionText">
        {stepDescriptionTextValue}
      </div>
      <div className='flex flex-row items-center mb-5 text-sm'>
        <div className="flex flex-col items-center font-gilroy font-light">
          {additionalPrompts}
        </div>
      </div>
    </>
  );
};

const StepIncompleteHeader = ({ existingAccounts }) => {
  return (
    <>
      <div className="stepDescriptionText">
        {existingAccounts
          ? "Make sure you have all your accounts added"
          : "Tomo securely connects to your bank to determine spending power."}
      </div>
      <p className="mx-5 text-gray-600 pb-3">
        Since we never do credit checks, we consider your cash flow and banking history for approval and spending power determination.
      </p>
    </>
  );
};

export default LinkBankHeader;